import { alertResponseMessage } from "../actions/action-creators/response";
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.mjs';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const stringToUrl = (string) => {
    // return string = string ? string.toLowerCase().trim().replace(/\s+/g, '-') : "";
    try{
        if(string){
            string = string.toLowerCase().trim().replace(/[^a-z0-9\s]/gi, ' ');
            string = string.replace(/\s+/g, '-');
        }
        return string = string ?  string : "";
    }catch(e){
        return '';
    }
}

const urlToString = (string) => {
    return string = string ? string.trim().replace('-', ' ') : "";
}

const calculatePercent = (price, mrp, show_text=true) => {
    try{
        var percent = 0;
        if(mrp > 0 && mrp > price){
            const diff = (mrp-price);
            percent = (diff*100)/mrp;
        }
        if(percent > 0){
            return(
                <span className="product-label">
                    {/* <span className="sale">-{percent.toFixed()}%</span> */}
                    <span className="sale">{percent.toFixed()}%{show_text ? ' Off' : ''}</span>
                    {/* <span className="new">NEW</span> */}
                </span>
              );
        }else{
            return "";
        }
    }catch(e){
        return "";
    }
}

const toggleBodyLoader = (type) => {
    try{
        var elementOver = document.getElementById("bodyOverlay");
        // var elementSVG = document.querySelectorAll('#bodyOverlay > svg');

        if(type === 'load'){
            elementOver.classList.add("screen-overlay");
            elementOver.style.display = 'block';
        }else{
            elementOver.classList.remove("screen-overlay");
            elementOver.style.display = 'none';
        }
    }catch(e){
        return "";
    }
}
const linkHttp = (link) => {
    try{
        return link = (link.indexOf('://') === -1) ? 'http://' + link : link;
    }catch(e){
        return link = 'http://' + link;
    }
}
// Copy to clipboard
const copyClipBoard = async(e, text, message='') => {
    try{
        e.preventDefault();
        await navigator.clipboard.writeText(text);
        alertResponseMessage({alert_type: 1, message: `${message} Copied Successfully`});
    }catch(e){

    }
}

const getObjectValue = (obj, path) => {
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

// Helper to generate Video Thumbnail
const generateVideoThumb = (file) => {
    return new Promise((resolve) => {
        const video = document.createElement("video");
        video.src = URL.createObjectURL(file);
        video.currentTime = 1; // Capture frame at 1 second
        video.onloadeddata = () => {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const thumb = canvas.toDataURL("image/jpeg");
            URL.revokeObjectURL(video.src);
            resolve(thumb);
        };
    });
};

// Helper for PDF (Requires pdfjs-dist library)
const generatePdfThumb = async (file) => {
    // You must point to the worker source for PDF.js to function
    try {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        const page = await pdf.getPage(1); // Get the first page

        const viewport = page.getViewport({ scale: 0.5 }); // Scale down for a thumbnail
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
            canvasContext: context,
            viewport: viewport,
        };

        await page.render(renderContext).promise;
        
        // Return the image as a Base64 string
        return canvas.toDataURL("image/jpeg", 0.8); 
    } catch (error) {
        console.error("PDF Thumbnail error:", error);
        return "/assets/images/placeholder/pdf.jpg";// Fallback
    } 
};

export {stringToUrl,
        calculatePercent,
        urlToString,
        toggleBodyLoader,
        linkHttp,
        copyClipBoard,
        getObjectValue,
        generateVideoThumb,
        generatePdfThumb
    };